// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32, Double } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  isPresented: boolean;
  acknowledgedEvent: Int32;
  revision: Int32;
  arrowEdge: string;
  presentationCompactAdaptation: string;
  contentWidth: Double;
  contentHeight: Double;
  onNativePopoverIsPresentedChange?: DirectEventHandler<Readonly<{
    isPresented: boolean;
    eventCount: Int32;
    revision: Int32;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativePopover';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativePopover",
  directEventTypes: {
    topNativePopoverIsPresentedChange: {
      registrationName: "onNativePopoverIsPresentedChange"
    }
  },
  validAttributes: {
    isPresented: true,
    acknowledgedEvent: true,
    revision: true,
    arrowEdge: true,
    presentationCompactAdaptation: true,
    contentWidth: true,
    contentHeight: true,
    ...ConditionallyIgnoredEventHandlers({
      onNativePopoverIsPresentedChange: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);